<div class="modal inmodal fade in parcel-modal create-edit-parcel-modal create-notice-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title">Notice Info</h4>
                </div>
                <div class="modal-body">
                    <!-- ___ Report Area ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Notice Name</label>
                        </div>
                        <div class="col-md-8">
                            <input class="form-control" name="noticeName" [ngModel]="data.noticeName" required>
                        </div>
                    </div>

                    <!-- ___ Type ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Notice Category</label>
                        </div>
                        <div class="col-md-8 fourteenPixelText type-dropdown-z-index-increase">
                            <search-select [ngModel]="data.categoryId" name="noticeCategory"
                                           required #noticeCategory [data]="noticeCategorySelect(categories)"></search-select>
                        </div>
                    </div>

                    <div class="_footer" *ngIf="noticesService.step && noticesService.step != 'main'">
                        <div class="_f-wrap">
                            <a (click)="back()" class="btn btn-back btn-default btn-lg">Back</a>
                            <button type="submit" class="btn btn-save btn-primary btn-lg">
                                <span *ngIf="noticesService.step != 'schedule'">Save & Continue</span>
                                <span *ngIf="noticesService.step == 'schedule'">Save</span>
                            </button>
                            <div class="_steps-items">
                                <ul>
                                    <li [ngClass]="{'active': noticesService.step == 'message' || noticesService.step == 'templates'}"
                                        class="passed"><span>Notice Message</span>
                                    </li>
                                    <li [ngClass]="{'active': noticesService.step == 'schedule'}" class="passed"><span>Schedule</span></li>
                                    <li [ngClass]="{'active': noticesService.step == 'info'}"><span>Notice Info</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/notices/notice-info-modal/notice-info-modal.component.html